export default "__VITE_ASSET__RLSbyZVPRh3E$63xFaJzAA__"